export default function createPaymentMethodTranslations(translations) {
  if (!translations) {
    return {};
  }

  return Object.entries(translations)
    .reduce((acc, [key, localeTranslation]) => {
      acc[key] = {
        name: localeTranslation?.name ?? '',
        description: localeTranslation?.description ?? '',
        withdrawDescription: localeTranslation?.withdrawal_description ?? '',
        additionalInformation: localeTranslation?.additional_information ?? '',
      };

      return acc;
    }, {});
}
